import { render, staticRenderFns } from "./addImagery.vue?vue&type=template&id=128f206c&scoped=true&"
import script from "./addImagery.vue?vue&type=script&lang=js&"
export * from "./addImagery.vue?vue&type=script&lang=js&"
import style0 from "./addImagery.vue?vue&type=style&index=0&id=128f206c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f206c",
  null
  
)

export default component.exports